import React from 'react'
import PropTypes from 'prop-types'

function CompetitionHeader({
  competitionSlug,
}) {
  const titleFirstLine = I18n.t(`competition.${competitionSlug}.header.title.first_line_html`)
  const titleSecondLine = I18n.t(`competition.${competitionSlug}.header.title.second_line_html`)
  const titleDescription = I18n.t(`competition.${competitionSlug}.header.title.description_html`)

  return (
    <header className="container-fixed">
      <div className="row">
        <div className="col-sm-12 col-md-6 offset-1 empty-form">
          <div className="competition-header__heading">
            <h1 className="competition-header__title">
              <span dangerouslySetInnerHTML={{ __html: titleFirstLine }} /><br />
              <span dangerouslySetInnerHTML={{ __html: titleSecondLine }} />
            </h1>
            <p className="competition-header__description" dangerouslySetInnerHTML={{ __html: titleDescription }} />
          </div>
        </div>
      </div>
    </header>
  )
}

CompetitionHeader.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default CompetitionHeader
